<template class="full-heigth">
  <div class="full-heigth" style="padding: 15px">
    <el-form v-if="isAdmin" :inline="true" class="filter-form">
      <el-form-item label="旅行社" style="width: 100%" class="agency-select-item">
        <el-select
          :disabled="isAdmin ? false : true"
          v-model="agencyCode"
          filterable
          placeholder="請選擇旅行社"
          style="width: 100%"
        >
          <el-option
            v-for="item in agencyList"
            :key="item.key"
            :label="item.val"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <el-form :inline="true" class="filter-form">
      <el-form-item label="QA問答內容查詢">
        <el-input v-model="listQueryByChatLog.search" placeholder="請輸入QA問答內容"></el-input>
      </el-form-item>

      <el-button
        type="primary"
        @click="getChatLogs"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>
      <el-button type="success" @click="handleDownloadExcel" :disabled="!aiAgentIsEnabled"
        >下載問答紀錄</el-button
      >
      <el-button type="warning" @click="handleSetQAPrompt" :disabled="!aiAgentIsEnabled"
        >設定QA內容</el-button
      >
      <el-button type="info" @click="handleAiQaUi" :disabled="!aiAgentIsEnabled"
        >虛擬人介面設定</el-button
      >
      <el-switch
        v-model="aiAgentIsEnabled"
        active-color="#13ce66"
        inactive-color="#ff4949"
        @change="handleIsEnabledOnSwitch"
        style="margin-left: 5px"
      ></el-switch>
    </el-form>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="listByChatLog"
        border
        fit
        highlight-current-row
        height="calc(75vh - 120px)"
        overflow-x="auto"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="團名" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.travelName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="發問人" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.userName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="QA的日期時間" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="Q的問題" min-width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.questions }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="A的答案" min-width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.answers }}</span>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="listQueryByChatLog.total > 0"
        layout="prev, pager, next"
        :total="listQueryByChatLog.total"
        :page.sync="listQueryByChatLog.page"
        :limit.sync="listQueryByChatLog.limit"
        @pagination="getChatLogs(agencyCode)"
      />
    </div>
    <el-dialog
      v-loading="listLoading || aiLoading"
      top="5vh"
      :title="'設定QA內容'"
      :visible.sync="dialogVisibleBySetQA"
      width="70%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="formBySetQA">
          <el-form-item label="" prop="content">
            <el-input
              type="textarea"
              placeholder="請輸入QA內容"
              v-model="formBySetQA.qaPrompt"
              :disabled="listLoading || aiLoading"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" :disabled="listLoading || aiLoading" @click="saveBySetQAPrompt">
          儲 存
        </el-button>
        <el-button type="danger" :disabled="listLoading || aiLoading" @click="closeBySetQAPrompt">
          關 閉
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-loading="listLoading || aiLoading"
      :title="'下載問答紀錄'"
      :visible.sync="dialogVisibleByDownloadExcel"
      width="40%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="formByDownloadExcel">
          <el-form-item label="選擇時間區間" prop="dateRange">
            <el-date-picker
              v-model="formByDownloadExcel.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              :disabled="listLoading || aiLoading"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="success"
          :disabled="listLoading || aiLoading"
          @click="enterByDownloadExcel"
        >
          下 載
        </el-button>
        <el-button type="danger" :disabled="listLoading || aiLoading" @click="closeByDownloadExcel">
          關 閉
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-loading="listLoading || aiLoading"
      :title="'虛擬人介面設定'"
      :visible.sync="dialogVisibleByAiQaUi"
      width="60%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="formByAiQaUi">
          <el-form-item label="靜態圖片 URL">
            <el-input v-model="formByAiQaUi.idleImageUrl" placeholder="JPG / PNG / GIF 網址" />
          </el-form-item>

          <el-form-item label="開場影片 URL">
            <el-input v-model="formByAiQaUi.openingVideoUrl" placeholder="進站自動播放影片網址" />
          </el-form-item>

          <el-form-item label="回答影片 URL">
            <el-input v-model="formByAiQaUi.replyVideoUrl" placeholder="AI 回答中循環影片網址" />
          </el-form-item>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" :disabled="listLoading || aiLoading" @click="saveByAiQaUi">
          保 存
        </el-button>
        <el-button type="danger" :disabled="listLoading || aiLoading" @click="closeByAiQaUi">
          關 閉
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import {
  getAiAgentChatLogForPaged,
  downloadAiAgentChatLogsToExcel,
  generateOrSaveChatAgent,
  getAiAgentQAPrompt,
  getAiAgentByCode,
} from '@/api/aiagent'
import checkPermission from '@/utils/permission'
import { getAgencyOptions } from '@/api/agency'

export default {
  name: 'AiFunctionCommentator',
  components: {
    Pagination,
  },
  data() {
    return {
      aiAgent: null,
      formBySetQA: {
        qaPrompt: '',
      },
      formByDownloadExcel: {
        dateRange: this.getDefaultDateRange(),
      },
      formByAiQaUi: {
        idleImageUrl: '',
        openingVideoUrl: '',
        replyVideoUrl: '',
      },
      aiAgentIsEnabled: false,
      aiLoading: false,
      listLoading: false,
      listByChatLog: [],
      dialogVisibleBySetQA: false,
      dialogVisibleByDownloadExcel: false,
      dialogVisibleByAiQaUi: false,
      listQueryByChatLog: {
        search: '',
        page: 1,
        limit: 10,
        total: 0,
      },
      agencyCode:
        this.$store.getters.userInfo && this.$store.getters.userInfo.agencyCode
          ? this.$store.getters.userInfo.agencyCode
          : null, // 限制不可選擇大於今日的日期
      pickerOptions: {
        disabledDate(time) {
          // time.getTime() 若大於當前時間則禁用 (回傳 true 代表禁用)
          return time.getTime() > Date.now()
        },
      },
      agencyList: [],
      isAdmin: checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN']),
    }
  },
  computed: {},
  async created() {
    await this.getAgencyOptions()
    await this.getAiAgent(this.agencyCode)
  },
  watch: {
    async agencyCode(newValue) {
      await this.getAiAgent(newValue)
    },
    async listLoading(newValue) {
      if (newValue) {
        try {
          await this.$store.dispatch('app/showDownloadLoading', true)
          await this.$store.dispatch('app/showDownloadLoadingText', '資料處理中，請稍後')
        } catch (error) {
          console.error('Loading 初始化失敗:', error)
          await this.$store.dispatch('app/showDownloadLoading', false)
        }
      } else {
        await this.$store.dispatch('app/showDownloadLoading', false)
      }
    },
    async aiLoading(newValue) {
      if (newValue) {
        try {
          await this.$store.dispatch('app/showAIProcessLoading', true)
          await this.$store.dispatch(
            'app/showAIProcessLoadingText',
            'AI處理資料中，請不要離開此畫面，感謝您的耐心等候。'
          )
        } catch (error) {
          console.error('Loading 初始化失敗:', error)
          await this.$store.dispatch('app/showAIProcessLoading', false)
        }
      } else {
        await this.$store.dispatch('app/showAIProcessLoading', false)
      }
    },
  },
  methods: {
    async getAgencyOptions() {
      this.listLoading = true
      await getAgencyOptions()
        .then(response => {
          this.agencyList = response.data
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    async handleIsEnabledOnSwitch() {
      const text = this.aiAgentIsEnabled ? '開啟' : '關閉'
      if (confirm(`確定要${text}AI客服嗎？`)) {
        this.aiLoading = true
        const response = await generateOrSaveChatAgent({
          agencyCode: this.agencyCode,
          isEnabled: this.aiAgentIsEnabled,
        })
          .then(res => {
            if (res.success) {
              this.getAiAgent(this.agencyCode)
              this.$message({
                message: `${text}成功`,
                type: 'success',
              })
            }
          })
          .catch(error => {
            console.error(error)
            this.$message({
              message: `${text}時發生錯誤: ${error.message}`,
              type: 'error',
            })
          })
          .finally(() => {
            this.aiLoading = false
            this.dialogVisibleBySetQA = false
          })
      } else {
        this.aiAgentIsEnabled = !this.aiAgentIsEnabled
      }
    },
    async getAiAgent(agencyCode) {
      await getAiAgentByCode({ agencyCode }).then(async res => {
        if (res.success) {
          this.aiAgent = res.data
          this.aiAgentIsEnabled = res.data.isEnabled

          await this.getChatLogs(this.agencyCode)
        }
      })
    },
    async handleAiQaUi() {
      await this.getAiAgent(this.agencyCode)
      this.formByAiQaUi = {
        idleImageUrl: this.aiAgent.idleImageUrl || '',
        openingVideoUrl: this.aiAgent.openingVideoUrl || '',
        replyVideoUrl: this.aiAgent.replyVideoUrl || '',
      }
      this.dialogVisibleByAiQaUi = true
    },
    async saveByAiQaUi() {
      if (confirm(`確定要將目前的虛擬人介面設定保存嗎？`)) {
        this.aiLoading = true
        const response = await generateOrSaveChatAgent({
          agencyCode: this.agencyCode,
          idleImageUrl: this.formByAiQaUi.idleImageUrl,
          openingVideoUrl: this.formByAiQaUi.openingVideoUrl,
          replyVideoUrl: this.formByAiQaUi.replyVideoUrl,
        })
          .then(async res => {
            if (res.success) {
              await this.getAiAgent(this.agencyCode)
              this.$message({
                message: '虛擬人介面設定已成功保存',
                type: 'success',
              })
            }
          })
          .catch(error => {
            console.error(error)
            this.$message({
              message: `保存虛擬人介面設定時發生錯誤: ${error.message}`,
              type: 'error',
            })
          })
          .finally(() => {
            this.aiLoading = false
            this.dialogVisibleByAiQaUi = false
          })
      }
    },
    async closeByAiQaUi() {
      this.formByAiQaUi = {
        idleImageUrl: '',
        openingVideoUrl: '',
        replyVideoUrl: '',
      }
      this.dialogVisibleByAiQaUi = false
    },
    async handleDownloadExcel() {
      this.dialogVisibleByDownloadExcel = true
    },
    async enterByDownloadExcel() {
      const startDate = this.formByDownloadExcel.dateRange[0]
      const endDate = this.formByDownloadExcel.dateRange[1]
      await this.exportToExcelByChatLog({
        startDate,
        endDate,
      })
      this.dialogVisibleByDownloadExcel = false
    },
    async closeByDownloadExcel() {
      this.formByDownloadExcel = {
        dateRange: this.getDefaultDateRange(),
      }
      this.dialogVisibleByDownloadExcel = false
    },
    async handleSetQAPrompt() {
      this.listLoading = true
      await getAiAgentQAPrompt({
        agencyCode: this.agencyCode,
      })
        .then(async res => {
          if (res.success) {
            await this.getAiAgent(this.agencyCode)
            this.formBySetQA.qaPrompt = res.data || ''
            this.dialogVisibleBySetQA = true
          }
        })
        .catch(error => {
          console.error(error)
          this.$message({
            message: `取得QA內容時發生錯誤: ${error.message}`,
            type: 'error',
          })
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    async saveBySetQAPrompt() {
      if (confirm(`確定要將目前的QA內容保存嗎？`)) {
        this.aiLoading = true
        const response = await generateOrSaveChatAgent({
          agencyCode: this.agencyCode,
          qaPrompt: this.formBySetQA.qaPrompt,
        })
          .then(res => {
            if (res.success) {
              this.$message({
                message: 'QA內容已成功保存',
                type: 'success',
              })
            }
          })
          .catch(error => {
            console.error(error)
            this.$message({
              message: `保存QA內容時發生錯誤: ${error.message}`,
              type: 'error',
            })
          })
          .finally(() => {
            this.aiLoading = false
            this.dialogVisibleBySetQA = false
          })
      }
    },
    async closeBySetQAPrompt() {
      this.dialogVisibleBySetQA = false
    },
    async refresh() {
      this.listQueryByChatLog.page = 1
      this.getChatLogs(this.agencyCode)
    },
    async getChatLogs() {
      if (!this.aiAgentIsEnabled) {
        this.$message({
          message: `請先開啟AI客服功能再進行查詢`,
          type: 'error',
        })
        return false
      }

      this.listLoading = true
      try {
        const response = await getAiAgentChatLogForPaged({
          ...this.listQueryByChatLog,
          agencyCode: this.agencyCode,
        })
        if (response.success && response.data) {
          this.listByChatLog = response.data.data || []
          this.listQueryByChatLog.total = response.data.total || 0
        }
        this.listLoading = false
      } catch (error) {
        console.error(error)
      }
      this.listLoading = false
    },
    async exportToExcelByChatLog(search) {
      this.listLoading = true

      try {
        const response = await downloadAiAgentChatLogsToExcel({
          ...search,
          agencyCode: this.agencyCode,
        })

        let fileName = `AI客服問答紀錄匯出_${new Date().getTime()}.xlsx`
        const contentDisposition = response.headers['content-disposition']
        if (contentDisposition) {
          const fileNameMatch =
            contentDisposition.match(/filename\*=utf-8''(.+)/i) ||
            contentDisposition.match(/filename=(.+)/i)
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = decodeURIComponent(fileNameMatch[1])
          }
        }

        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName)
        } else {
          const downloadElement = document.createElement('a')
          const href = window.URL.createObjectURL(blob)

          downloadElement.href = href
          downloadElement.download = fileName
          document.body.appendChild(downloadElement)
          downloadElement.click()

          document.body.removeChild(downloadElement)
          window.URL.revokeObjectURL(href)
        }

        this.$message({
          message: 'Excel 檔案下載成功！',
          type: 'success',
        })
      } catch (error) {
        console.error('匯出失敗:', error)
      } finally {
        this.listLoading = false
      }
    },
    getDefaultDateRange() {
      const end = new Date()
      const start = new Date()
      // 將月份減 1 (即回推一個月)
      start.setMonth(start.getMonth() - 1)

      // 格式化為 yyyy-MM-dd 格式字串
      const formatDate = date => {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        return `${y}-${m}-${d}`
      }

      return [formatDate(start), formatDate(end)]
    },
  },
}
</script>
<style lang="scss">
.el-textarea__inner {
  height: 60vh !important;
}

.agency-select-item {
  .el-form-item__content {
    width: 100%;
  }
}
</style>
